import React from 'react';
import { Box } from '@mui/material';
import './styles.css';
import { DataGrid } from "@mui/x-data-grid";

const MiTabla = ({ data, columns, density = 'standard', boxHeight = '80vh', ...props }) => {

    return (

        <Box 
            sx={{ 
                height: boxHeight,
                width: '100%'
            }}
        >
            <DataGrid
                rows={data}
                columns={columns}
                // onRowClick={rowClick}
                density={density}
                className="custom-data-grid"
                loading={false}
                slotProps={{
                    loadingOverlay: {
                      variant: 'skeleton',
                      noRowsVariant: 'skeleton',
                    },
                }}
                { ...props }
            />

        </Box>

    )

}

export default MiTabla